module.exports = __webpack_public_path__ + "static/media/portfolio-img5.08c9320c.jpg";